var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.96531 0C1.45353 0 0.962713 0.203304 0.60083 0.565186C0.238949 0.927069 0.0356445 1.41788 0.0356445 1.92967V12.2212C0.0356445 12.733 0.238949 13.2238 0.60083 13.5857C0.962712 13.9476 1.45353 14.1508 1.96531 14.1508H7.02237C6.78442 13.3579 6.9065 12.4597 7.38862 11.7744H3.68835C3.47831 11.7744 3.30805 11.6042 3.30805 11.3941C3.30805 9.29381 5.01071 7.59115 7.11105 7.59115C8.57564 7.59115 9.84685 8.41905 10.4822 9.6324C10.5253 9.53131 10.5596 9.42546 10.5842 9.31572L10.6137 9.18144C11.007 7.38443 12.7923 6.73541 14.1866 7.24216V1.92967C14.1866 1.41788 13.9832 0.927069 13.6213 0.565186C13.2594 0.203304 12.7686 0 12.2569 0H1.96531ZM7.11105 6.45653C8.37125 6.45653 9.39284 5.43494 9.39284 4.17473C9.39284 2.91453 8.37125 1.89294 7.11105 1.89294C5.85085 1.89294 4.82924 2.91453 4.82924 4.17473C4.82924 5.43494 5.85085 6.45653 7.11105 6.45653ZM12.1845 9.5253C12.4291 8.4079 14.0202 8.40095 14.2745 9.51617L14.2872 9.57178C14.2958 9.60991 14.3039 9.64584 14.3126 9.68269C14.6297 11.0333 15.7227 12.0653 17.091 12.3034C18.2554 12.506 18.2554 14.1775 17.091 14.3801C15.7155 14.6194 14.618 15.6611 14.3076 17.0224L14.2745 17.1673C14.0202 18.2825 12.4291 18.2756 12.1845 17.1582L12.1573 17.0338C11.8582 15.6674 10.7621 14.6177 9.38404 14.378C8.22196 14.1758 8.22196 12.5076 9.38404 12.3054C10.7573 12.0665 11.8506 11.0233 12.1542 9.66388L12.1744 9.57184L12.1845 9.5253Z",
    fill: "url(#paint0_linear_708_1801)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_708_1801",
    x1: 0.0356445,
    y1: 18,
    x2: 4.50698,
    y2: -2.8816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD90EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25BDD9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileColor);
export default __webpack_public_path__ + "static/media/profileColor.452a64a290cba9be8481dc793ae2d977.svg";
export { ForwardRef as ReactComponent };